import React, { useState } from 'react';
import { useServices } from '../../../core/services/useServices';
import { LoadingOutlined } from '@ant-design/icons';
import Endpoints, { SOURCE } from '../../../core/constants/endpoints';
import { useQueryClient } from 'react-query';
import { Spinner } from '../../../components/Spinner';
import { SpinnerWrapper } from '../../../components/styles';
import Modal from '../../../components/Modal';
import { useActions } from '../../../context/Actions.context';
import styled from 'styled-components';
import showNotification from '../../../section/Common/utils/showNotification';

const WarningText = styled.p`
  font-size: 16px;
  margin-right: 12px;
`;

interface IProps {
  book_ids: [];
  onClose: Function;
  onReset: Function;
  open: boolean;
  isPinning: boolean;
  id: string;
}

const PinUnpinSelectedTitles: React.FC<IProps> = ({ open, id, book_ids, isPinning, onClose, onReset }) => {
  const { book: { updateTitle } } = useServices();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const data: { [key: string]: any } = {};
  const { source: sourcePath, setActionLoading } = useActions();
  const sourceTab = window.location.pathname.split('/')[2];

  if (sourcePath['source'] === SOURCE.bookstat) {
    data.amazonasin = book_ids;
  } else if (sourcePath['source'] === SOURCE['royal-road']) {
    data.fiction_id = book_ids;
  } else if (sourcePath['source'] === SOURCE.ao3) {
    data.work_id = book_ids;
  }

  const handleClose = () => {
    onClose();
  };

  const onConfirm = async () => {
    setActionLoading(true);
    setLoading(true);

    const payload = {
      is_pinned_watchlist: isPinning ? 1 : 0,
      pin_action: isPinning ? 'pin' : 'unpin'
    };

    const promise = updateTitle(
      {
        source: sourcePath['source'],
        endpoint: Endpoints[id],
        sourceTab,
        action: id
      },
      data,
      payload
    );

    showNotification(
      promise,
      `Successfully ${isPinning ? 'pinned' : 'unpinned'} title(s).`,
      `Failed to ${isPinning ? 'pin' : 'unpin'} title(s).`
    );

    try {
      const response = await promise;

      setLoading(false);
      handleClose();
      onReset();

      if (response?.status === 200) {
        queryClient.refetchQueries(`get-row-count${id}`);
        queryClient.refetchQueries(`get-${id}`);
      }
    } catch (error) {
      setLoading(false);
      handleClose();
      onReset();

      console.error(`Failed to ${isPinning ? 'pin' : 'unpin'} title(s)`, {
        sourceTab,
        error
      });
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <Modal
      okText='Yes'
      cancelText='No'
      visible={open}
      onOk={onConfirm}
      onCancel={handleClose}
      confirmLoading={loading}
    >
      <WarningText>
        You are about to {isPinning ? 'pin' : 'unpin'} {book_ids?.length} title(s).
        Do you wish to continue?
      </WarningText>

      {loading && (
        <SpinnerWrapper>
          <Spinner
            size='large'
            spinning={loading}
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 34
                }}
                spin
              />
            }
          />
        </SpinnerWrapper>
      )}
    </Modal>
  );
};

export default React.memo(PinUnpinSelectedTitles);
